import { type Icons, Tag, type TagProps } from "@virtual-brain-lib/frontend-design-system/ui";
import {
	type ContentSource,
	DOCUMENT_TYPE_BY_MIME_TYPE,
	type DocumentType,
	type TaggableMimeType,
	TEXT_HTML_MIME_TYPE,
} from "@virtual-brain-lib/types";

const tagInfos = {
	audio: {
		label: "AUDIO",
		icon: "podcast",
		color: "info",
	},
	csv: {
		label: "CSV",
		icon: "fileAlt",
		color: "success",
	},
	drive: {
		label: "DRIVE",
		icon: "hardDrive",
		color: "info",
	},
	excel: {
		label: "EXCEL",
		icon: "fileAlt",
		color: "success",
	},
	file: {
		label: "FILE",
		icon: "file",
		color: "info",
	},
	folder: {
		label: "FOLDER",
		icon: "folder",
		color: "warning",
	},
	html: {
		label: "HTML",
		icon: "fileAlt",
		color: "info",
	},
	image: {
		label: "IMG",
		icon: "image",
		color: "success",
	},
	link: {
		label: "LINK",
		icon: "link",
		color: "info",
	},
	markdown: {
		label: "MD",
		icon: "fileAlt",
		color: "info",
	},
	msg: {
		label: "MSG",
		icon: "letter",
		color: "info",
	},
	pdf: {
		label: "PDF",
		icon: "fileAlt",
		color: "purple",
	},
	powerpoint: {
		label: "PPTX",
		icon: "fileAlt",
		color: "orange",
	},
	word: {
		label: "DOCX",
		icon: "fileAlt",
		color: "info",
	},
	workspace: {
		label: "WORKSPACE",
		icon: "sharepoint",
		color: "success",
	},
	youtube: {
		label: "YOUTUBE",
		icon: "youtube",
		color: "warning",
	},
} as const satisfies Record<DocumentType, { label: string; color: TagProps["color"]; icon: Icons }>;

export type ContentMimeTypeTagProps = {
	readonly mimeType: TaggableMimeType;
	readonly source?: ContentSource | undefined;
	readonly size?: TagProps["size"];
} & Pick<TagProps, "className">;

export function ContentMimeTypeTag({ mimeType, source, className, size }: ContentMimeTypeTagProps) {
	if (mimeType === TEXT_HTML_MIME_TYPE && source === "web") {
		return (
			<Tag size={size} leftIcon="link">
				LINK
			</Tag>
		);
	}

	const tag = tagInfos?.[DOCUMENT_TYPE_BY_MIME_TYPE?.[mimeType]];

	if (!tag) {
		return <Tag className={className} color="danger" leftIcon="forbidden" size={size} />;
	}

	const { color, label, icon } = tag;

	return (
		<Tag className={className} color={color} leftIcon={icon} size={size}>
			{label}
		</Tag>
	);
}
